import { render, staticRenderFns } from "./BFreezeLabelInfo.vue?vue&type=template&id=0f03de54&"
import script from "./BFreezeLabelInfo.vue?vue&type=script&lang=js&"
export * from "./BFreezeLabelInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports